<button mat-stroked-button>
  <mat-icon>back</mat-icon>
</button>
